/** @module Apparel/PriceList/ChangeFreezeStatusController */
define([
    "dojo/_base/declare",
    "csi/heading/BooleanController",
    "csi/locale",
    "csi/widget/MessageDialog",
    "csi/xml"
], function(declare,BooleanController,locale,MessageDialog,xml) {

    return declare(BooleanController, {

        _isDragAndFill: function() {
            return !!this.pasteList;
        },
        
        /**
         * Confirmation is needed when the user attempts to unfreeze the row.
         */
        hasToConfirmAction: function() {
            var price = this.getNode();
            // confirm when unfreezing, e.g. when setting freeze status to false
            // e.g. when drag-fill, when the source node is unfrozen, otherwise when the node is frozen
            return this._isDragAndFill() ? !price.FreezeStatus : price.FreezeStatus; 
        },

        /**
         * Prompt confirmation with buttons “Unfreeze” and “Cancel”.
         * @param {Object} params
         */
        confirmAction: function(params) {
            params = params || {};
            params.title = this.m_action.m_name;
            params.message = locale.typeAction("Price", "ChangeFreezeStatus_Confirm");
            params.buttons = ["UNFREEZE_PRICE", MessageDialog.BUTTON_CANCEL];
            this.inherited(arguments);
        },

        /**
         * Process when unfreeze is confirmed
         * @param {String} key
         */
        onConfirm: function(key) {
            if (key == "UNFREEZE_PRICE") {
                if (this._isDragAndFill()) {
                    this.preProcess(); // arag-fill is done in preProcess
                } else {
                    this.process(true);
                }
            } else {
                this.postProcess();
            }
        }
        
    });
});